module.exports = __webpack_public_path__ + "img/edit.fa8122db.svg";